import httpClient from '@/http-client'

export const get = (options = {}) => {
    return httpClient
        .get('/api/collateral-records', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
    return httpClient
        .post('/api/collateral-records', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
    return httpClient
        .put(`/api/collateral-records/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
    return httpClient
        .delete(`/api/collateral-records/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const withdraw = (id, data) => {
    return httpClient
        .put(`/api/collateral-records/withdraw/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const collateralAssets = (options = {}) => {
    return httpClient
        .get('/api/collateral-records/collateral-assets', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const loans = (options = {}) => {
    return httpClient
        .get('/api/collateral-records/loans', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default { get, store, update, destroy, withdraw, collateralAssets, loans }
